export const pt = {
    defaultTitle: `Resultado da ação`,
    processingTitle: `Processando...`,
    processingDescription: `Por favor aguarde enquanto processamos sua solicitação`,
    success: `Ação concluída com sucesso`,
    error: `Ocorreu um erro`,
    unexpectedError: `Ocorreu um erro inesperado. Por favor tente novamente.`,
    serverUnavailable: `O servidor está indisponível. Por favor tente novamente mais tarde.`,
    networkUnavailable: `Não foi possível conectar ao servidor. Verifique sua conexão com a internet.`,
    redirect: `Redirecionando em {count} segundos...`,
    continueNow: `Continuar agora`,
};
//# sourceMappingURL=pt.js.map